import { GraphQLQueryClass } from "@bsm/component";
import { TBankInformation } from "@bsm/graphql";

export class BankQuery implements GraphQLQueryClass<TBankInformation, TResponse>
{
    public queryKey: string = "App.Bsm.BankQuery";

    public gql: string = `
    query($id:Float!){
        bankInformation(filter:{id:$id}){
            id
            bankName
            bankAdress
            iban
            currency
            isEditable
            isDeletable
        }
    }
   `;
    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): TBankInformation {
        return data.bankInformation;
    }
}

export type TResponse = {
    bankInformation: TBankInformation;
};
